import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Layout } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';

import { HeaderSearch } from 'shared/headerSearch/HeaderSearch';
import HeaderAccount from 'components/atoms/HeaderAccount';
import { RootState } from 'store';
import { setLayoutSideBarCollapsed } from 'store/baseLayoutSettings/action';

import './BaseLayoutHeader.scss';

const { Header } = Layout;

function BaseLayoutHeader() {
  const {
    sideBarCollapsed,
    sideBarWidth,
    sideBarCollapsedWidth,
    mainHeaderHeight,
  } = useSelector((state: RootState) => state.baseLayoutSettings);
  const dispatch = useDispatch();

  const SideBarCollapsedButton = sideBarCollapsed
    ? MenuUnfoldOutlined
    : MenuFoldOutlined;

  return (
    <>
      <Header
        style={{
          backgroundColor: 'transparent',
          height: `${mainHeaderHeight}px`,
          lineHeight: `${mainHeaderHeight}px`,
        }}
      />
      <Header
        className="BaseLayoutHeader"
        style={{
          width: `calc(100% - ${
            sideBarCollapsed ? sideBarCollapsedWidth : sideBarWidth
          }px)`,
          height: `${mainHeaderHeight}px`,
          lineHeight: `${mainHeaderHeight}px`,
        }}
      >
        <SideBarCollapsedButton
          className="BaseLayoutHeader__sidebar-collapsed-button"
          onClick={() => dispatch(setLayoutSideBarCollapsed(!sideBarCollapsed))}
        />
        <div className="BaseLayoutHeader__toolbar">
          <HeaderSearch />
          <HeaderAccount />
        </div>
      </Header>
    </>
  );
}

export default BaseLayoutHeader;
